/* eslint-disable no-unused-vars */
import React from "react";

export function PaginationToolbar(props) {
  const {isLoading, paginationProps, forwardRef, hidePageList} = props;
  const {
    sizePerPageList,
    sizePerPage,
    totalSize,
    onSizePerPageChange,
  } = paginationProps;

  const style = { width: "100px" };

  const onSizeChange = event => {
    const newSize = +event.target.value;
    onSizePerPageChange(newSize);
  };

  return (
    <div className="d-flex align-items-center pb-3 justify-content-end">
      {isLoading && (
        <div className="d-flex align-items-center mr-5">
          <div className="mr-2 text-muted">Loading...</div>
          <div className="spinner spinner-primary mr-10"></div>
        </div>
      )}

      <div className="d-flex flex-column mr-5" ref={forwardRef} />


      {!hidePageList && (
        <select
          disabled={totalSize === 0}
          className={`form-control form-control-sm font-weight-bold border-0 bg-light ${totalSize === 0 && "disabled"}`}
          onChange={onSizeChange}
          value={sizePerPage}
          style={style}
        >
          {sizePerPageList.map(option => {
            const isSelect = sizePerPage === `${option.value}`;
            return (
              <option key={option.text} value={option.value} className={`btn ${isSelect ? "active" : ""}`}>
                {option.text}
              </option>
            );
          })}
        </select>
      )}
      {/*<PaginationTotalStandalone className="text-muted" {...paginationProps} />*/}
    </div>
  );
}

export const ForwardedPaginationToolbar = React.forwardRef((props, ref) => (
  <PaginationToolbar {...props} forwardRef={ref} />
));
